import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { useClickGrouping } from 'components/grouping/views'
import { CommonSeriesSettings, Series, SeriesTemplate } from 'devextreme-react/chart'

export const NavBarChart: React.FunctionComponent = ({ }) => {
    const { toolbar, parameters } = useClickGrouping()
    return (
        <BPMChart title='Nav Bar' subTitle='By Menu Item' type='bar'
            toolBarItems={() => toolbar}
            additionalParams={{ ...parameters, entity_name: 'nav_bar' }}
            onRequestLoad={(options, signal) => BPMAnalyticsAPI.getv2<any>(`clicks/id`, options, signal)}
        >
            {!parameters.groupBy && <Series name='Click' />}

            {parameters.groupBy && <SeriesTemplate
                nameField={parameters.groupBy}
            />}

            <CommonSeriesSettings
                type={'bar'}
                valueField="count"
                argumentField="name">

            </CommonSeriesSettings>
        </BPMChart >
    )
}


// WEBPACK FOOTER //
// ./src/pages/Product/Pages/charts/NavBarChart.tsx